const slider1 = require("../../../assets/images/bannerSlider/one.jpg");
const slider2 = require("../../../assets/images/bannerSlider/two.jpg");
const slider3 = require("../../../assets/images/bannerSlider/three.jpg");
const slider4 = require("../../../assets/images/bannerSlider/four.jpg");
const slider5 = require("../../../assets/images/bannerSlider/five.jpg");
const slider6 = require("../../../assets/images/bannerSlider/six.jpg");

export const sliderContentArr = [
  {
    background: slider1,
    whitecontent: "OT SOLUTIONS",
    slideNo: "First Slide",
  },
  {
    background: slider2,
    whitecontent: "OT SOLUTIONS",
    greencontent: "TO MEET EVERY NEED",
    slideNo: "Second Slide",
  },
  {
    background: slider3,
    whitecontent: "USER EXPERIENCE",
    slideNo: "Third Slide",
  },
  {
    background: slider4,
    whitecontent: "USER EXPERIENCE",
    greencontent: "TAILORED TO YOUR REQUIREMENTS",
    slideNo: "Fourth Slide",
  },
  {
    background: slider5,
    whitecontent: "CLUSTER FREE",
    slideNo: "Fifth Slide",
  },
  {
    background: slider6,
    whitecontent: "HYGENIC DESIGN",
    slideNo: "Sixth Slide",
  },
];
